import { getFileBlob } from "utils"
import { app } from "config"
import { LOCAL_STORAGE_TAGS } from "constants/index"
import { Col, Row } from "reactstrap"
import { SaveButton } from "components/Buttons"
import React from "react"

export const fetchMenuItem = async (menuItem, eventId) => {
  const vendor_id = JSON.parse(
    localStorage.getItem(LOCAL_STORAGE_TAGS.VENDOR_ID_TAG)
  )

  let baseURL = `${app.APP_LAYER}/v${app.currentVersion}`
  let url = null
  let params = {
    vendor_id,
    menu_item_id: menuItem?.id,
    nc: new Date().getTime(),
  }
  switch (menuItem?.machine_name) {
    case "countdown_clock":
      url = "/countdown-clock"
      params = !!eventId ? { ...params, event_id: eventId } : params
      break
    case "documents":
      url = "/documents"
      params = !!eventId ? { ...params, event_id: eventId } : params
      break
    case "polls":
      url = "/poll"
      baseURL = `${app.POLLS_LAYER}/v${app.currentVersion}`
      params = !!eventId ? { ...params, event_id: eventId } : params
      break
    case "surveys":
      url = "/survey"
      baseURL = `${app.POLLS_LAYER}/v${app.currentVersion}`
      params = !!eventId ? { ...params, event_id: eventId } : params
      break
    case "lists":
      url = "/list"
      params = !!eventId ? { ...params, event_id: eventId } : params
      break
    case "custom_web_links":
      url = "/menu/container"
      params = !!eventId ? { ...params, event_id: eventId } : params
      break
    case "trivia_challenge":
      url = "/trivia"
      baseURL = `${app.POINTS_LAYER}/v${app.currentVersion}`
      params = !!eventId ? { ...params, event_id: eventId } : params
      break
    case "calendar":
      url = "/admin/calendar/menu-item"
      break

    case "questionnaires":
      url = "/questionnaire"
      baseURL = `${app.POINTS_LAYER}/v${app.currentVersion}`
      params = !!eventId ? { ...params, event_id: eventId } : params
      break
    case "booking_service":
    case "view_bookings":
      url = "/admin/booking/menu-item"

      break
    case "refer_friend":
      url = "/refer-friend/menu-item"

      break
    case "media":
      if (eventId) {
        url = "/event/" + eventId + "/gallery"
      } else {
        url = "/vendor/gallery"
      }

      break
    case "places":
      url = "/places/menu-item"
      break
    case "form_builders":
      url = "/form-builder"
      params = !!eventId ? { ...params, event_id: eventId } : params
      baseURL = `${app.POLLS_LAYER}/v${app.currentVersion}`
      break
    default:
      break
  }

  let item = null

  if (url) {
    const fetchURL = baseURL + url
    const response = await fetch(fetchURL + "?" + new URLSearchParams(params), {
      method: "GET",
      headers: {
        "X-Requested-From": "cms2",
        ["Authorization"]: `Bearer ${
          JSON.parse(localStorage.getItem(LOCAL_STORAGE_TAGS.AUTH_USER))
            .api_token
        }`,
      },
    })

    if (!response.ok) {
      throw new Error("Data coud not be fetched!")
    }

    item = await response?.json()
  }

  return item
}

export const publishWarningText = (menuName, items) => {
  let text = ""
  if (
    ["calendar", "booking_service", "view_bookings"].indexOf(menuName) !== -1
  ) {
    text =
      "The feature can not be published until you select at least one " +
      (menuName === "calendar" ? "calendar" : "booking type") +
      " and save. " +
      "If there are no " +
      (menuName === "calendar" ? "calendars" : "booking types") +
      ", you have to first create them."
  } else if (menuName === "refer_friend" || menuName === "places") {
    text = "You have to first save the setup for this menu item!"
  } else if (items?.length === 0) {
    text =
      "The feature can not be published until you create at least one feature entry."
  } else {
    text =
      "None of the feature entries on this list have a status of Published. Once you change" +
      " the status of one of the entries, the status of this list will become Published."
  }
  return text
}

export const mapBasicContentFormToApi = (values = {}) => ({
  vendor_id: values.vendorId,
  user_id: values.userId,
  title: values.title,
  content: values.content,
  menu_feature: 1,
  menu_item_id: values.menu_item_id,
  event_id: values.event_id,
  subtitle: values.subtitle && values.subtitle,
  image_caption: values.imageCaption,
  link_text: values.linkText,
  link: values.link,
  link_icon_id: values.link && parseInt(values.linkIcon),
  bg_color: values.backgroundColor,
  text_color: values.textColor,
  font_family: values.font,
  image: values.image && getFileBlob(values.image.editedImage),
  bg_image:
    values.backgroundImage && getFileBlob(values.backgroundImage.editedImage),
})

export const mapApiResponseToBasicContentForm = (apiResponse = {}) => ({
  title: apiResponse.title,
  content: apiResponse.content,
  subtitle: apiResponse.subtitle,
  imageCaption: apiResponse.image_caption,
  image: { editedImage: apiResponse.image_url },
  linkText: apiResponse.link_text,
  linkIcon: apiResponse.link_icon_id,
  backgroundColor: apiResponse.bg_color,
  textColor: apiResponse.text_color,
  font: apiResponse.font_family,
  backgroundImage: { editedImage: apiResponse.bg_image_url },
  link: apiResponse.link,
})

export const updatedBasicContentFormToApi = (newValues = {}) => {
  return {
    vendor_id: newValues.vendorId,
    user_id: newValues.userId,
    title: newValues.title,
    content: newValues.content,
    event_id: newValues.event_id,
    subtitle: newValues.subtitle && newValues.subtitle,
    image_caption: newValues.imageCaption,
    link_text: newValues.linkText,
    link: newValues.link,
    link_icon_id: newValues.link && parseInt(newValues.linkIcon),
    bg_color: newValues.backgroundColor,
    text_color: newValues.textColor,
    font_family: newValues.font,
    image: newValues.image && getFileBlob(newValues.image.editedImage),
    bg_image:
      newValues.backgroundImage &&
      getFileBlob(newValues.backgroundImage.editedImage),
    delete_image: newValues.deleteImage ? 1 : 0,
    delete_bg_image: newValues.deleteBackgroundImage ? 1 : 0,
  }
}

export const countdownClockFormToApi = (values = {}) => {
  const date = new Date(
    `${values.date} ${values.hour}:${values.minute} ${values.timeType} `
  )
  return {
    countdown_date: `${values.date} ${
      date.getHours() < 10 ? `0${date.getHours()}` : date.getHours()
    }:${
      date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()
    }:00`,
    countdown_time: "",
    event_id: values.eventId,
    menu_feature: values.menu_feature,
    menu_item_id: values.menu_item_id,
    order: values.order,
    status: 0,
    title: values.title,
    user_id: values.userId,
    vendor_id: values.vendorId,
  }
}

export const mapApiToCountdownClockForm = values => {
  const date = values.countdown_date.date.split(" ")
  const hour = parseInt(date[1].split(":")[0])
  return {
    title: values.title,
    date: date[0],
    hour: hour % 12 || 12,
    minute: date[1].split(":")[1],
    timeType: hour < 12 ? "AM" : "PM",
  }
}

export const mapDocumentToApi = (values = {}) => ({
  vendor_id: values.vendor_id,
  document: "",
  status: values.status,
  name: values.name || "Document",
  user_id: values.user_id,
  type: "file",
  menu_feature: values.menu_feature,
  menu_item_id: values.menu_item_id,
  order: values.order,
  can_export: 1,
  file: getFileBlob(values.document.dataURI, values.document?.name),
  event_id: values.event_id,
})

const dateISOFormat = (date, hour, minute, timeType) => {
  return new Date(`${date} ${hour}:${minute} ${timeType} `).toISOString()
}

const dateStringFormat = (date, hour, minute, timeType) => {
  const newDate = dateISOFormat(date, hour, minute, timeType).split("T")
  const _date = newDate[0]
  const _time = newDate[1].split(".")[0]
  return `${_date} ${_time}`
}

export const mapEventInfoToApi = (values = {}) => ({
  address: values?.address?.address,
  lat: values?.address?.lat,
  lon: values?.address?.lng,
  details: values.extraDetails,
  display_end_time: values.endHour ? true : false,
  display_start_time: values.startHour ? true : false,
  end_date:
    values.endDate &&
    dateStringFormat(
      values.endDate,
      values.endHour || "11",
      values.endMinute || "59",
      values.endTimeType || "AM"
    ),
  end_time:
    values.endHour &&
    dateISOFormat(
      values.endDate,
      values.endHour || "11",
      values.endMinute || "59",
      values.endTimeType || "AM"
    ),
  event_id: values.event_id,
  location_name: values.locationName,
  maybe_rsvp_enabled: values.rsvpOption === "1" && values.maybeOption,
  maybe_rsvp_takes_one_spot:
    values.rsvpOption === "1" && values.maybeOption && values.maybeOptionSpot,
  meeting_url: values.meetingLink,
  menu_feature: 1,
  menu_item_id: values.menu_item_id,
  name: values.name,
  show_rsvp: values.rsvpOption === "1",
  start_date:
    values.startDate &&
    dateStringFormat(
      values.startDate,
      values.startHour || "12",
      values.startMinute || "00",
      values.startTimeType || "AM"
    ),
  start_time:
    values.startHour &&
    dateISOFormat(
      values.startDate,
      values.startHour || "12",
      values.startMinute || "00",
      values.startTimeType || "AM"
    ),
  status: false,
  timezone: values.timezone,
  vendor_id: values.vendorId,
  yes_rsvp_limit: values.rsvpLimit || "",
  participants_per_rsvp_limit: values?.maxRsvp,
})

export const mapApiToEventInfoForm = apiResponse => {
  let startDate,
    startTime,
    endDate,
    endTime = ""
  if (apiResponse.start_date_object) {
    startDate = apiResponse.start_date_object.date.split(" ")
    startTime = startDate[1].split(":")
  }
  if (apiResponse.end_date_object) {
    endDate = apiResponse.end_date_object.date.split(" ")
    endTime = endDate[1].split(":")
  }
  return {
    name: apiResponse.name,
    startDate: apiResponse.start_date_object && startDate[0],
    startHour:
      apiResponse.display_start_time &&
      apiResponse.start_date_object &&
      (parseInt(startTime[0]) % 12 || 12),
    startMinute:
      apiResponse.display_start_time &&
      apiResponse.start_date_object &&
      startTime[1],
    startTimeType:
      apiResponse.display_start_time &&
      apiResponse.start_date_object &&
      parseInt(startTime[0]) < 12
        ? "AM"
        : "PM",
    endDate: apiResponse.end_date_object && endDate[0],
    endHour:
      apiResponse.display_end_time &&
      apiResponse.end_date_object &&
      (parseInt(endTime[0]) % 12 || 12),
    endMinute:
      apiResponse.display_end_time && apiResponse.end_date_object && endTime[1],
    endTimeType:
      apiResponse.display_end_time &&
      apiResponse.end_date_object &&
      parseInt(endTime[0]) < 12
        ? "AM"
        : "PM",
    locationName: apiResponse.location_name,
    address: { address: apiResponse.address },
    meetingLink: apiResponse.meeting_url,
    extraDetails: apiResponse.details,
    rsvpOption: apiResponse.show_rsvp ? "1" : "0",
    rsvpLimit: apiResponse.yes_rsvp_limit,
    maybeOption: apiResponse.maybe_rsvp_enabled,
    maybeOptionSpot: apiResponse.maybe_rsvp_takes_one_spot,
    maxRsvp: apiResponse?.participants_per_rsvp_limit,
  }
}

export const mapFormBuilderToApi = (values = {}) => {
  const questions = values.questions.map((question, index) => {
    return {
      answer_text_type:
        question.answerType === "2" ? question.textAnswerType : null,
      answer_type: question.answerType,
      answers:
        question.answerType === "1"
          ? question.id
            ? question.answers.filter(
                answer => answer && (answer.answer.trim() || answer.id)
              )
            : question.answers
                .filter(answer => answer && answer.answer.trim())
                .map(x => x.answer)
          : [],
      multiple:
        question.answerType === "1" && question.multipleAnswer
          ? question.multipleAnswer
          : 0,
      order: index,
      question: question.question,
      id: question.id ? question.id : null,
      optional: !question?.optional,
    }
  })

  const params = {
    vendor_id: values.vendor_id,
    user_id: values.user_id,
    name: values.name,
    status: values.status,
    menu_feature: values.menu_feature,
    menu_item_id: values.menu_item_id,
    can_retake: values.retake ? 1 : 0,
    retake_button_text: values.retakeText,
    order: values.order,
    description: values.description,
    event_id: values.event_id,
    image: values.image && getFileBlob(values.image.editedImage),
    delete_image: values.deleteImage ? 1 : 0,
    price: values?.price,
    include_responses_in_email: values.includeResponses ? 1 : 0,
  }

  return [questions, params]
}

export const mapApiToFormBuilder = ({form = {}, featureRecipients = []}) => {
  const formData = {
    retake: form.can_retake === 1 ? true : false,
    retakeText: form.retake_button_text,
    image: { editedImage: form.image_url || null },
    description: form.description,
    name: form.name,
    requirePayment: form?.price ? true : false,
    price: form?.price,
    includeResponses: form?.include_responses_in_email === 1 ? true : false,
    questions: form.questions.map(question => ({
      id: question.id,
      question: question.question,
      answerType: question.answer_type.toString(),
      multipleAnswer: question.multiple,
      textAnswerType:
        question.answer_text_type && question.answer_text_type.toString(),
      answers: question.answers.map(answer => answer),
      optional: !question?.optional,
    })),
  }
  const responses = {
    selectedAdmins: featureRecipients?.map(user => ({
      label: `${user.first_name} ${user.last_name} (${user.email})`,
      value: user.id,
    })),
  }
  return { formData, responses }
}

export const mapListItemsToApi = (values = [], vendorId) => {
  return values.map((item, index) => {
    return {
      vendor_id: vendorId,
      title_line_1: item.line1,
      title_line_2: item?.line2 || "",
      title_line_3: item?.line3 || "",
      order: item?.order || index,
      description: item?.details || "",
      bg_color: item?.backgroundColor || "#FFFFFF",
      text_color: item?.textColor || "#FFFFFF",
      font_family: item?.fontFamily,
      links:
        item?.listItemButtons &&
        item?.listItemButtons.map(button => ({
          id: button?.id || null,
          list_item_id: button?.list_item_id || null,
          text: button.name,
          url: button.link,
          icon_id: button?.icon_id || null,
        })),
      file: item?.image && getFileBlob(item?.image?.editedImage),
      bg_image:
        item?.backgroundImage && getFileBlob(item?.backgroundImage.editedImage),
    }
  })
}

export const mapApiResponseToListForm = (apiResponse = []) => {
  return apiResponse.map(item => ({
    image: item?.file && { editedImage: item.file.url },
    line1: item?.title_line_1,
    line2: item?.title_line_2,
    line3: item?.title_line_3,
    backgroundColor: item.bg_color,
    textColor: item.text_color,
    listItemButtons:
      item.links &&
      item.links.map(button => ({
        id: button.id,
        icon_id: button.icon_id,
        list_item_id: button.list_item_id,
        name: button.text,
        link: button.url,
      })),
    backgroundImage: item?.bg_image && { editedImage: item.bg_image.url },
    fontFamily: item?.font_family,
    details: item?.description,
    list_id: item.list_id,
    id: item.id,
  }))
}

export const mapUpdatedListItemsToApi = (values = [], vendorId) => {
  return values.map((item, index) => {
    return {
      vendor_id: vendorId,
      title_line_1: item.line1,
      title_line_2: item?.line2 || "",
      title_line_3: item?.line3 || "",
      order: item?.order || index,
      description: item?.details || "",
      delete_file: item?.deleteImage ? 1 : 0,
      delete_bg_image: item?.deleteBackgroundImage ? 1 : 0,
      bg_color: item?.backgroundColor || "#FFFFFF",
      text_color: item?.textColor || "#FFFFFF",
      font_family: item?.fontFamily,
      links:
        item?.listItemButtons &&
        item?.listItemButtons.map(button => ({
          id: button?.id || null,
          list_item_id: button?.list_item_id || null,
          text: button.name,
          url: button.link,
          icon_id: button?.icon_id || null,
        })),
      file: item?.image && getFileBlob(item?.image?.editedImage),
      bg_image:
        item?.backgroundImage && getFileBlob(item?.backgroundImage.editedImage),
      list_id: item.list_id,
      id: item.id,
    }
  })
}

export const mapPlacesFormToApi = (values = {}) => ({
  vendor_id: values.vendorId,
  provide_feedback_enabled: values?.feedback ? 1 : 0,
  show_map_search: values?.enableMapSearch ? 1 : 0,
  ratings_enabled: values?.enableStarRatings ? 1 : 0,
  hide_public_rating:
    values?.enableStarRatings && values?.hidePublicRating ? 1 : 0,
  starred_locations_enabled: values?.enableStarredLocations ? 1 : 0,
  starred_text: values.enableStarredLocations && values?.starredLocationLabel,
  show_sponsor: values?.enableSponsoredBanner ? 1 : 0,
  sponsor_url: values?.sponsorUrl,
  map_url: values?.mapUrl,
  menu_item_id: values.menu_item_id,
  zoom_level: values?.zoomLevel,
  default_user_location: values?.centerMap ? 1 : 0,
  center_map_address: values?.centerMapAddress,
  center_map_lat: values?.centerMapLatitude || undefined,
  center_map_lon: values?.centerMapLongitude || undefined,
  google_maps_key: values?.mapKey,
  survey_reminder_notification: values?.enableNotification ? 1 : 0,
  send_notification_minutes: values?.notificationReminder,
  survey_id_notification: values?.notificationsurvey,
  survey_id_provide_feedback: values?.survey,
  delete_banner: values?.deleteBanner ? 1 : 0,
  banner_file:
    values?.sponsorBanner && getFileBlob(values?.sponsorBanner?.editedImage),
})

export const mapApiResponseToPlacesForm = apiResponse => ({
  feedback: apiResponse.provide_feedback_enabled === 1,
  enableMapSearch: apiResponse.show_map_search === 1,
  enableStarRatings: apiResponse.ratings_enabled === 1,
  hidePublicRating: apiResponse.hide_public_rating === 1,
  enableStarredLocations: apiResponse.starred_locations_enabled === 1,
  starredLocationLabel: apiResponse.starred_text,
  enableSponsoredBanner: apiResponse.show_sponsor === 1,
  sponsorUrl: apiResponse.sponsor_url,
  mapUrl: apiResponse.map_url,
  zoomLevel: apiResponse.zoom_level,
  centerMap: apiResponse.default_user_location === 1,
  centerMapAddress: apiResponse.center_map_address,
  centerMapLatitude: apiResponse.center_map_lat,
  centerMapLongitude: apiResponse.center_map_lon,
  mapKey: apiResponse.google_maps_key,
  enableNotification: apiResponse.survey_reminder_notification === 1,
  notificationReminder: apiResponse.send_notification_minutes,
  notificationsurvey: apiResponse.survey_id_notification,
  survey: apiResponse.survey_id_provide_feedback,
  sponsorBanner: { editedImage: apiResponse?.banner_url || null },
})

export const mapPollToApi = (values = {}) => {
  const answers = []
  values?.options?.forEach(option => {
    if (option.answer && option.answer.trim()) {
      answers.push(option.answer)
    }
  })
  const questions = [
    {
      question: values.question,
      answers: answers,
      multiple: 0,
      order: 0,
    },
  ]

  const poll = {
    chart_type: values.chartType,
    event_id: values.event_id,
    menu_feature: values.menu_feature,
    menu_item_id: values.menu_item_id,
    name: values.name,
    order: values.order,
    results_metrics: values.resultMetrics,
    status: values.status,
    user_id: values.user_id,
    vendor_id: values.vendor_id,
  }

  return [questions, poll]
}

export const mapApiResponseToPoll = apiResponse => ({
  chartType: apiResponse.chart_type.toString(),
  resultMetrics: apiResponse.results_metrics.toString(),
  question: apiResponse.question.question,
  options: apiResponse.question.answers,
  name: apiResponse.name,
})

export const mapUpdatedPollToApi = (newValues, currentValues) => {
  const answers = newValues.options.filter(
    option => option.answer && option.answer.trim()
  )
  const answerIds = newValues.options.map(x => x.id)
  currentValues.question.answers.forEach(item => {
    if (!answerIds.includes(item.id)) {
      answers.push({ id: item.id, answer: "" })
    }
  })
  const questions = {
    ...currentValues.question,
    answers: answers,
    question: newValues.question,
  }
  const poll = {
    ...currentValues,
    chart_type: newValues.chartType,
    results_metrics: newValues.resultMetrics,
    name: newValues?.name || currentValues.name,
    question: {
      ...currentValues.question,
      answers: answers,
      question: newValues.question,
    },
  }

  return [questions, poll]
}

export const mapQuestionnaireToApi = (values = {}) => {
  const questions = values.questions.map((question, index) => ({
    answers: question.answers,
    multiple: false,
    order: index,
    question: question.question,
    type: question.questionType,
  }))
  const questionnaire = {
    event_id: values.eventId,
    headline: values?.headline || "",
    menu_feature: values.menu_feature,
    menu_item_id: values.menu_item_id,
    name: values.name,
    order: values.order,
    retake_action: values.retakeOption,
    retake_after: values.allowRetake || 0,
    retake_button_text: values.retakeText,
    retake_period: values?.retakeValue || null,
    retake_period_type: values?.retakeType || null,
    status: values.status,
    subtext: values?.subtext || "",
    user_id: values.userId,
    vendor_id: values.vendorId,
  }
  return [questions, questionnaire]
}

export const mapApiResponseToQuestionnaire = apiResponse => {
  return {
    retakeText: apiResponse.retake_button_text,
    retakeOption: apiResponse.retake_action.toString(),
    questions: apiResponse.questions.map(question => ({
      questionType: question.type.toString(),
      answers: question.answers.map(answer => ({
        ...answer,
        value: answer.value.toString(),
      })),
      id: question.id,
      question: question.question,
      order: question.order,
    })),
    headline: apiResponse?.headline || "",
    subtext: apiResponse?.subtext || "",
    allowRetake: apiResponse.retake_period !== null,
    retakeValue:
      apiResponse?.retake_period !== null
        ? apiResponse?.retake_period.toString()
        : null,
    retakeType:
      apiResponse.retake_period_type !== null
        ? apiResponse?.retake_period_type.toString()
        : null,
  }
}

export const mapUpdatedQuestionnaireToApi = (newValues = {}, currentValues) => {
  const newQuestions = []
  const updatedQuestions = []
  newValues.questions.forEach((question, index) => {
    if (!question.id) {
      newQuestions.push({
        answers: question.answers,
        multiple: false,
        order: index,
        question: question.question,
        type: question.questionType,
      })
    } else {
      updatedQuestions.push({
        answers: question.answers.map(answer => ({
          id: answer?.id || null,
          answer: answer.answer,
          value: answer.value,
        })),
        multiple: false,
        order: index,
        question: question.question,
        type: question.questionType,
        id: question.id,
      })
    }
  })
  const questionnaire = {
    ...currentValues,
    name: newValues?.name || currentValues?.name,
    headline: newValues?.headline || "",
    retake_action: newValues?.retakeOption,
    retake_after: newValues?.allowRetake ? 1 : 0,
    retake_button_text: newValues?.retakeText,
    retake_period: newValues?.retakeValue || null,
    etake_period_type: newValues?.retakeType || null,
    subtext: newValues?.subtext || "",
  }
  return [newQuestions, updatedQuestions, questionnaire]
}

export const mapQuestionnaireResultToApi = (values = {}) => ({
  disclaimer: values?.description || "",
  display_submission_datetime: values?.displayDate ? 1 : 0,
  headline: values?.headline,
  questionnaire_id: values.entity_id,
  resultsets: values.results.map(result => ({
    bottom_color: result.bottomGradientColor,
    font_color: result.textColor,
    max_value: result.maxScore,
    min_value: result.minScore,
    title: result.title,
    text: result.description,
    top_color: result.topGradientColor,
  })),
  storing_period: values.storingPeriod,
  vendor_id: values.vendorId,
})

export const mapApiResponseToQuestionnaireResult = apiResponse => ({
  description: apiResponse?.disclaimer,
  displayDate: apiResponse.display_submission_datetime === 1,
  headline: apiResponse.headline,
  results: apiResponse.resultsets.map(result => ({
    bottomGradientColor: result.bottom_color,
    textColor: result.font_color,
    maxScore: result.max_value,
    minScore: result.min_value,
    title: result.title,
    description: result.text,
    topGradientColor: result.top_color,
  })),
  storingPeriod: apiResponse.storing_period.toString(),
})

export const mapSurveyToApi = (values = {}) => {
  const questions = values.questionsList.map((question, index) => ({
    answer_type: question.answerType,
    answers:
      question.answerType === "1"
        ? question.answers
            .filter(answer => answer?.answer && answer?.answer?.trim())
            .map(answer => answer.answer)
        : [],
    multiple:
      question.answerType === "2" ? false : question.multipleAnswer || false,
    optional: question.optionalQuestion || false,
    order: index,
    question: question.question,
  }))

  const survey = {
    vendor_id: values.vendorId,
    user_id: values.userId,
    name: values.name,
    status: values.status,
    menu_feature: values.menu_feature,
    menu_item_id: values.menu_item_id,
    order: values.order,
    single_screen: values?.singleScreenLayout ? 1 : 0,
    can_retake: values?.retake ? 1 : 0,
    delete_image: values?.deleteImage ? 1 : 0,
    is_for_places: values?.placesSurvey ? 1 : 0,
    chart_type: 2, //???
    results_metrics: 0, //???
    description: values?.description,
    retake_button_text: values?.retakeText,
    event_id: values.eventId,
    image: getFileBlob(values?.image?.editedImage),
    include_responses_in_email: values?.includeResponses ? 1 : 0,
  }

  return [questions, survey]
}

export const mapApiToSurveyForm = ({ survey = {}, featureRecipients = [] }) => {
  const questions = {
    name: survey?.name,
    singleScreenLayout: survey.single_screen === 1,
    retake: survey.can_retake === 1,
    placesSurvey: survey.is_for_places === 1,
    description: survey?.description,
    retakeText: survey?.retake_button_text,
    image: { editedImage: survey?.image_url },
    includeResponses: survey?.include_responses_in_email === 1,
    questionsList: survey.questions.map(question => ({
      answerType: question.answer_type.toString(),
      answers: question.answer_type === 1 ? question.answers : [],
      multipleAnswer: question.multiple,
      order: question.order,
      question: question.question,
      id: question?.id,
      optionalQuestion: question?.optional,
    })),
  }
  featureRecipients = {
    feedback: survey?.submission_feedback,
    selectedAdmins: featureRecipients?.map(user => ({
      label: `${user.first_name} ${user.last_name} (${user.email})`,
      value: user.id,
    })),
  }
  return { questions, featureRecipients }
}

export const mapUpdatedSurveyToApi = (newValues = {}, currentValues) => {
  const newQuestions = []
  const updatedQuestions = []
  newValues.questionsList.forEach((question, index) => {
    if (!question.id) {
      newQuestions.push({
        answer_type: question.answerType,
        answers:
          question.answerType === "1"
            ? question.answers
                .filter(answer => answer?.answer && answer?.answer?.trim())
                .map(answer => answer.answer)
            : [],
        multiple:
          question.answerType === "2"
            ? false
            : question.multipleAnswer || false,
        order: index,
        question: question.question,
        optional: question.optionalQuestion || false,
      })
    } else {
      updatedQuestions.push({
        answer_type: question.answerType,
        answers:
          question.answerType === "1"
            ? question.answers.filter(
                answer =>
                  answer.id ||
                  (!answer.id && answer?.answer && answer?.answer?.trim())
              )
            : [],
        multiple:
          question.answerType === "2"
            ? false
            : question.multipleAnswer || false,
        order: index,
        question: question.question,
        optional: question.optionalQuestion || false,
        id: question.id,
      })
    }
  })
  let survey = {
    ...currentValues,
    name: newValues?.name || currentValues.name,
    description: newValues?.description,
    retake_button_text: newValues?.retakeText,
    description: newValues?.description,
    is_for_places: newValues?.placesSurvey ? 1 : 0,
    delete_image: newValues?.deleteImage ? 1 : 0,
    single_screen: newValues?.singleScreenLayout ? 1 : 0,
    can_retake: newValues?.retake ? 1 : 0,
    include_responses_in_email: newValues?.includeResponses ? 1 : 0,
  }
  if (newValues?.image?.editedImage) {
    if (
      (currentValues?.image_url && newValues?.deleteImage) ||
      !currentValues?.image_url
    ) {
      survey = { ...survey, image: getFileBlob(newValues?.image?.editedImage) }
    }
  }
  return [newQuestions, updatedQuestions, survey]
}

export const mapTriviaChallengeToAPi = (values = {}) => {
  const questions = values.questions.map((question, index) => ({
    multiple: false,
    order: index,
    question: question.question,
    answers: question.answers.map(answer => ({
      answer: answer.answer,
      right_answer: answer.answer === question.correctAnswer,
    })),
    right_answer_text: question.correctAnswer,
  }))

  const trivia = {
    event_id: values.eventId,
    menu_feature: values.menu_feature,
    menu_item_id: values.menu_item_id,
    name: values.name,
    order: values.order,
    status: values.status,
    user_id: values.userId,
    vendor_id: values.vendorId,
  }

  return [questions, trivia]
}

export const mapApiResponseToTrivia = apiResponse => ({
  questions: apiResponse.questions.map(question => ({
    answers: question.answers,
    id: question.id,
    order: question.order,
    question: question.question,
    correctAnswer: question.answers.find(answer => answer.right_answer === true)
      .answer,
  })),
  name: apiResponse.name,
})

export const mapUpdatedTriviaToApi = (newValues = {}, currentValues) => {
  const newQuestions = []
  const updatedQuestions = []
  newValues.questions.forEach((question, index) => {
    const newAnswers = []
    question?.answers?.forEach(answer => {
      if (answer.answer && answer.answer.trim() !== "") {
        newAnswers.push({
          ...answer,
          right_answer: answer.answer === question.correctAnswer,
        })
      }
    })
    const questionItem = currentValues?.questions?.find(
      q => q?.id === question?.id
    )
    if (!!questionItem) {
      questionItem?.answers?.forEach(ans => {
        if (!newAnswers?.some(newAns => newAns?.id === ans?.id)) {
          newAnswers.push({ id: ans?.id, answer: "" })
        }
      })
    }
    if (!question.id) {
      newQuestions.push({
        multiple: false,
        order: index,
        question: question.question,
        answers: newAnswers,
        right_answer_text: question.correctAnswer,
      })
    } else {
      updatedQuestions.push({
        multiple: false,
        order: index,
        question: question.question,
        answers: newAnswers,
        right_answer_text: question.correctAnswer,
        id: question.id,
      })
    }
  })
  const trivia = {
    ...currentValues,
    name: newValues?.name || currentValues.name,
  }

  return [newQuestions, updatedQuestions, trivia]
}

export const mapWebLinkToApiForm = (values = {}) => {
  let links = []
  if (values.webLinkScreenType === "1") {
    links = [
      {
        all_events: false,
        browser_controls_type: values?.browserOption || 0,
        can_open_externally: values?.externalBrowser ? 1 : 0,
        entity_type: "promo_link",
        event_id: values.eventId,
        events: [],
        id: null,
        label: values?.name,
        menu_feature: values.menu_feature,
        menu_icon_id: 81,
        order: 0,
        status: 0,
        url: values?.linkType === "1" ? values?.webUrl : null,
        vendor_id: values.vendorId,
        phone: values?.linkType === "3" ? values?.phoneNumber : null,
        android_deeplink:
          values?.linkType === "2" ? values?.androidDeeplink : null,
        ios_deeplink: values?.linkType === "2" ? values?.IOSdeeplink : null,
        // open_as_app: values?.openAsApp,
        ios_store_link: values?.appStoreLink,
        android_store_link: values?.googleStoreLink,
      },
    ]
  } else {
    links = values.multiWebLink.map((link, index) => ({
      all_events: false,
      browser_controls_type: link?.browserOption || 0,
      can_open_externally: false,
      entity_type: "promo_link",
      event_id: values.eventId,
      events: [],
      id: null,
      label: link?.name,
      menu_feature: values.menu_feature,
      menu_icon_id: link.linkIcon,
      order: index,
      status: 0,
      vendor_id: values.vendorId,
      url: link?.linkType === "1" ? link?.webUrl : null,
      phone: link?.linkType === "3" ? link?.phoneNumber : null,
      android_deeplink: link?.linkType === "2" ? link?.androidDeeplink : null,
      ios_deeplink: link?.linkType === "2" ? link?.IOSdeeplink : null,
      ios_store_link: link?.linkType === "2" ? link?.appStoreLink : null,
      android_store_link: link?.linkType === "2" ? link?.googleStoreLink : null,
      // open_as_app: link?.openAsApp,
    }))
  }
  const container = {
    all_events: false,
    event_id: values.eventId,
    label: values.label,
    menu_feature: values.menu_feature,
    menu_icon_id: 81,
    menu_item_id: values.menu_item_id,
    order: values.order,
    status: values.status,
    vendor_id: values.vendorId,
  }

  return [container, links]
}

export const mapUpdatedWebLinkToApi = (newValues = {}, currentValues) => {
  const container = {
    ...currentValues,
    label: newValues?.name || currentValues.label,
  }
  let updatedLinks = []
  let newLinks = []
  if (newValues.webLinkScreenType === "1") {
    if (!newValues.linkId) {
      newLinks = [
        {
          all_events: false,
          browser_controls_type: newValues?.browserOption || 0,
          can_open_externally: newValues?.externalBrowser ? 1 : 0,
          entity_type: "promo_link",
          event_id: currentValues.event_id,
          events: [],
          id: null,
          label: newValues?.name,
          menu_feature: currentValues.menu_feature,
          menu_icon_id: 81,
          order: 0,
          status: 0,
          url: newValues?.linkType === "1" ? newValues?.webUrl : null,
          vendor_id: currentValues.vendorId,
          phone: newValues?.linkType === "3" ? newValues?.phoneNumber : null,
          android_deeplink:
            newValues?.linkType === "2" ? newValues?.androidDeeplink : null,
          ios_deeplink:
            newValues?.linkType === "2" ? newValues?.IOSdeeplink : null,
          ios_store_link:
            newValues?.linkType === "2" ? newValues?.appStoreLink : null,
          android_store_link:
            newValues?.linkType === "2" ? newValues?.googleStoreLink : null,
          // open_as_app: newValues?.openAsApp,
        },
      ]
    } else {
      const current =
        currentValues.promo_links.find(x => x.id === newValues?.linkId) || {}
      updatedLinks = [
        {
          ...current,
          label: newValues?.name || current.label,
          browser_controls_type: newValues?.browserOption || 0,
          can_open_externally: newValues?.externalBrowser ? 1 : 0,
          id: newValues.linkId,
          url: newValues?.linkType === "1" ? newValues?.webUrl : null,
          vendor_id: currentValues.vendorId,
          phone: newValues?.linkType === "3" ? newValues?.phoneNumber : null,
          android_deeplink:
            newValues?.linkType === "2" ? newValues?.androidDeeplink : null,
          ios_deeplink:
            newValues?.linkType === "2" ? newValues?.IOSdeeplink : null,
          ios_store_link:
            newValues?.linkType === "2" ? newValues?.appStoreLink : null,
          android_store_link:
            newValues?.linkType === "2" ? newValues?.googleStoreLink : null,
          // open_as_app: newValues?.openAsApp,
        },
      ]
    }
  } else {
    newValues.multiWebLink.forEach((link, index) => {
      if (link?.id) {
        const current =
          currentValues.promo_links.find(x => x.id === link?.id) || {}
        updatedLinks.push({
          ...current,
          order: index,
          browser_controls_type: link?.browserOption || 0,
          label: link.name,
          menu_icon_id: link.linkIcon,
          url: link?.linkType === "1" ? link?.webUrl : null,
          phone: link?.linkType === "3" ? link?.phoneNumber : null,
          android_deeplink:
            link?.linkType === "2" ? link?.androidDeeplink : null,
          ios_deeplink: link?.linkType === "2" ? link?.IOSdeeplink : null,
          ios_store_link: link?.linkType === "2" ? link?.appStoreLink : null,
          android_store_link:
            link?.linkType === "2" ? link?.googleStoreLink : null,
          // open_as_app: link?.openAsApp,
        })
      } else {
        newLinks.push({
          all_events: false,
          browser_controls_type: link?.browserOption || 0,
          can_open_externally: false,
          entity_type: "promo_link",
          event_id: currentValues.event_id,
          events: [],
          id: null,
          label: link?.name,
          menu_feature: currentValues.menu_feature,
          menu_icon_id: link.linkIcon,
          order: index,
          status: 0,
          vendor_id: currentValues.vendor_id,
          url: link?.linkType === "1" ? link?.webUrl : null,
          phone: link?.linkType === "3" ? link?.phoneNumber : null,
          android_deeplink:
            link?.linkType === "2" ? link?.androidDeeplink : null,
          ios_deeplink: link?.linkType === "2" ? link?.IOSdeeplink : null,
          ios_store_link: link?.linkType === "2" ? link?.appStoreLink : null,
          android_store_link:
            link?.linkType === "2" ? link?.googleStoreLink : null,
          // open_as_app: link?.openAsApp,
        })
      }
    })
  }
  const currentLinkIds = currentValues.promo_links.map(x => x.id)
  const updatedLinkIds = updatedLinks.map(x => x.id)
  const deletableLinkIds = currentLinkIds.filter(
    x => !updatedLinkIds.includes(x)
  )
  return [updatedLinks, newLinks, container, deletableLinkIds]
}

export const mapApiToWebLinkForm = apiResponse => {
  if (apiResponse.promo_links.length > 1) {
    return {
      name: apiResponse.label,
      webLinkScreenType: "2",
      multiWebLink: apiResponse.promo_links.map(link => ({
        linkIcon: link.icon.id.toString(),
        name: link.label,
        webUrl: link.url,
        browserOption: link.browser_controls_type.toString(),
        id: link.id,
        linkType: !!link?.phone
          ? "3"
          : !!link?.android_deeplink || !!link?.ios_deeplink
          ? "2"
          : "1",
        phoneNumber: link?.phone,
        androidDeeplink: link?.android_deeplink,
        IOSdeeplink: link?.ios_deeplink,
        appStoreLink: link?.ios_store_link,
        googleStoreLink: link?.android_store_link,
        // openAsApp: link?.open_as_app,
      })),
    }
  } else {
    return {
      name: apiResponse.label,
      webLinkScreenType: "1",
      webUrl: apiResponse.promo_links[0].url,
      linkId: apiResponse.promo_links[0].id,
      externalBrowser: apiResponse.promo_links[0].can_open_externally === 1,
      browserOption:
        apiResponse.promo_links[0].browser_controls_type?.toString(),
      linkType: !!apiResponse.promo_links[0]?.phone
        ? "3"
        : !!apiResponse?.promo_links[0]?.url
        ? "1"
        : "2",
      phoneNumber: apiResponse.promo_links[0]?.phone,
      androidDeeplink: apiResponse?.promo_links[0]?.android_deeplink,
      IOSdeeplink: apiResponse?.promo_links[0]?.ios_deeplink,
      appStoreLink: apiResponse?.promo_links[0]?.ios_store_link,
      googleStoreLink: apiResponse?.promo_links[0]?.android_store_link,
      // openAsApp: apiResponse?.promo_links[0]?.open_as_app,
    }
  }
}

export const mapApiToPMForm = apiResponse => {
  return {
    private_message_form: {
      layout: apiResponse?.template_id.toString(),
      receivers: apiResponse?.pm_setup_type,
      tagSearch: apiResponse?.receiveUsersTags?.map(tag => ({
        ...tag,
        label: tag?.tag,
        value: tag?.id,
      })),
      userSearch: apiResponse?.pmUsers?.map(user => ({
        ...user,
        label: `${user.first_name} ${user.last_name} (${user.email})`,
        value: user.id,
      })),
      adminSetupEnabled:
        apiResponse?.admin_setup_type === "tags" ||
        apiResponse?.admin_setup_type === "users",
      adminUsers: apiResponse?.admin_setup_type,
      adminReceivers: apiResponse?.admin_users_setup_type,
      adminUserSearch: apiResponse?.admins?.map(user => ({
        ...user,
        label: `${user.first_name} ${user.last_name} (${user.email})`,
        value: user.id,
      })),
      adminReceiverUserSearch: apiResponse?.adminReceiveUsers?.map(user => ({
        ...user,
        label: `${user.first_name} ${user.last_name} (${user.email})`,
        value: user.id,
      })),
      adminTagSearch: apiResponse?.adminTags?.map(tag => ({
        ...tag,
        label: tag?.tag,
        value: tag?.id,
      })),
      adminReceiverTagSearch: apiResponse?.adminReceiveUsersTags?.map(tag => ({
        ...tag,
        label: tag?.tag,
        value: tag?.id,
      })),
      mediaUploadEnabled: apiResponse?.can_upload === 1,
      mediaUsers: apiResponse?.media_upload_access_type,
      mediaUserSearch: apiResponse?.mediaUploadUsers?.map(user => ({
        ...user,
        label: `${user.first_name} ${user.last_name} (${user.email})`,
        value: user.id,
      })),
      mediaTagSearch: apiResponse?.tags?.map(tag => ({
        ...tag,
        label: tag?.tag,
        value: tag?.id,
      })),
      group_chat_only: apiResponse?.group_chat_only || false,
    },
  }
}

export const mapPMFormToApi = data => {
  return {
    template_id: data.private_message_form.layout,
    pm_setup_type: data?.private_message_form?.receivers,
    receiveUsersTags:
      data?.private_message_form?.receivers === "tags"
        ? data?.private_message_form?.tagSearch
        : [],
    pmUsers:
      data?.private_message_form?.receivers === "users"
        ? data?.private_message_form?.userSearch
        : [],
    adminSetupEnabled: data?.private_message_form?.adminSetupEnabled ? 1 : 0,
    admin_setup_type: data?.private_message_form?.adminUsers,
    admin_users_setup_type: data?.private_message_form?.adminReceivers,
    admins:
      data?.private_message_form?.adminUsers === "users"
        ? data?.private_message_form?.adminUserSearch
        : [],
    adminReceiveUsers:
      data?.private_message_form?.adminReceivers === "users"
        ? data?.private_message_form?.adminReceiverUserSearch
        : [],
    adminTags:
      data?.private_message_form?.adminUsers === "tags"
        ? data?.private_message_form?.adminTagSearch
        : [],
    adminReceiveUsersTags:
      data?.private_message_form?.adminReceivers === "tags"
        ? data?.private_message_form?.adminReceiverTagSearch
        : [],
    can_upload: data?.private_message_form?.mediaUploadEnabled ? 1 : 0,
    media_upload_access_type: data?.private_message_form?.mediaUsers,
    mediaUploadUsers:
      data?.private_message_form?.mediaUsers === "users"
        ? data?.private_message_form?.mediaUserSearch
        : [],
    tags:
      data?.private_message_form?.mediaUsers === "tags"
        ? data?.private_message_form?.mediaTagSearch
        : [],
    tag_ids:
      data?.private_message_form?.mediaUsers === "tags"
        ? data?.private_message_form?.mediaTagSearch?.map(tag => tag?.value)
        : [],
    user_ids: [],
  }
}

export const mapApiToVideoCallForm = (apiResponse = {}) => {
  return {
    video_call_form: {
      receivers: apiResponse?.video_call_setup_type,
      tagSearch: apiResponse?.receiveUsersTags?.map(tag => ({
        ...tag,
        label: tag?.tag,
        value: tag?.id,
      })),
      userSearch: apiResponse?.videoCallUsers?.map(user => ({
        ...user,
        label: `${user.first_name} ${user.last_name} (${user.email})`,
        value: user.id,
      })),
      adminSetupEnabled:
        apiResponse?.admin_setup_type === "tags" ||
        apiResponse?.admin_setup_type === "users",
      adminUsers: apiResponse?.admin_setup_type,
      adminReceivers: apiResponse?.admin_users_setup_type,
      adminUserSearch: apiResponse?.admins?.map(user => ({
        ...user,
        label: `${user.first_name} ${user.last_name} (${user.email})`,
        value: user.id,
      })),
      adminReceiverUserSearch: apiResponse?.adminReceiveUsers?.map(user => ({
        ...user,
        label: `${user.first_name} ${user.last_name} (${user.email})`,
        value: user.id,
      })),
      adminTagSearch: apiResponse?.adminTags?.map(tag => ({
        ...tag,
        label: tag?.tag,
        value: tag?.id,
      })),
      adminReceiverTagSearch: apiResponse?.adminReceiveUsersTags?.map(tag => ({
        ...tag,
        label: tag?.tag,
        value: tag?.id,
      })),
    },
  }
}

export const mapVideoCallFormToApi = data => {
  return {
    video_call_setup_type: data?.video_call_form?.receivers,
    receiveUsersTags:
      data?.video_call_form?.receivers === "tags"
        ? data?.video_call_form?.tagSearch
        : [],
    videoCallUsers:
      data?.video_call_form?.receivers === "users"
        ? data?.video_call_form?.userSearch
        : [],
    adminSetupEnabled: data?.video_call_form?.adminSetupEnabled ? 1 : 0,
    admin_setup_type: data?.video_call_form?.adminUsers,
    admin_users_setup_type: data?.video_call_form?.adminReceivers,
    admins:
      data?.video_call_form?.adminUsers === "users"
        ? data?.video_call_form?.adminUserSearch
        : [],
    adminReceiveUsers:
      data?.video_call_form?.adminReceivers === "users"
        ? data?.video_call_form?.adminReceiverUserSearch
        : [],
    adminTags:
      data?.video_call_form?.adminUsers === "tags"
        ? data?.video_call_form?.adminTagSearch
        : [],
    adminReceiveUsersTags:
      data?.video_call_form?.adminReceivers === "tags"
        ? data?.video_call_form?.adminReceiverTagSearch
        : [],
  }
}

export const CloneFeatureModal = ({
  featureName,
  loading,
  handleCloseModal,
  handleClone,
}) => {
  return (
    <React.Fragment>
      <Row>
        <Col xs={12}>
          <p>
            Changing any fields in this {featureName} will lock it, making it
            unavailable to users and the final data will be saved in your
            reports as of today’s date.
          </p>
        </Col>
        <Col xs={12}>
          <p>
            This restriction is necessary because responses have already been
            received, and modifying the {featureName} would invalidate the
            previously collected data. As a result, you will no longer be able
            to collect responses using this {featureName} once it is edited.
          </p>
        </Col>
        <Col xs={12}>
          <p>
            To proceed with changes while maintaining data integrity, use the
            CLONE option to create a duplicate of this {featureName}. The
            duplicate will include your edits and remain available to users.
          </p>
          <p>For assistance, please contact your Mobile Coach.</p>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col>
          <SaveButton
            type="button"
            fullWidth={true}
            color="danger"
            content="Cancel"
            onClick={handleCloseModal}
          />
        </Col>
        <Col>
          <SaveButton
            content="Clone"
            fullWidth={true}
            onClick={handleClone}
            loading={loading}
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}
